import React, { useEffect, useState } from "react";
import Header from "./header";
import List from "./list";
import { MccListWithPaginate } from "../../../api";
import styles from "./styles.module.scss";
import AddAndEditMCC from "./add-and-edit-modal";
import useMccStore from "../../stores/mcc";
import { toast, ToastBar, Toaster } from "react-hot-toast";
import CloseIconWhite from "../../assets/svg/icons/common/CloseIconWhite";

const MCCPage = () => {

  const [isLoading, setIsLoading] = useState(false);
  const mccList = useMccStore((state) => state.mccList);
  const setMccList = useMccStore((state) => state.setMccList);
  const page = useMccStore((state) => state.page);
  const setPage = useMccStore((state) => state.setPage);
  const searchFilters = useMccStore((state) => state.searchFilters);
  const setSearchFilters = useMccStore((state) => state.setSearchFilters);
  const isAddMCCModalOpen = useMccStore((state) => state.isAddMCCModalOpen);
  const setIsAddMCCModalOpen = useMccStore((state) => state.setIsAddMCCModalOpen);
  const pageCount = useMccStore((state) => state.pageCount);
  const setPageCount = useMccStore((state) => state.setPageCount);
  const setTotalItems = useMccStore((state) => state.setTotalItems);

  const closeModal = () => {
    setIsAddMCCModalOpen(false);
  };

  const getMCCList = async () => {
    setIsLoading(true);
    try {
      const res = await MccListWithPaginate(page, searchFilters);

      if (res.success) {
        let last_page = res?.data?.last_page;
        setPageCount(last_page)
        setMccList(res.data.data);
        if(res?.data?.total){
          setTotalItems(res?.data?.total)
        }
      } else {
        setMccList([]);
      }
    } catch (error) {
      console.log("error :>> ", error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getMCCList();
  }, [
    searchFilters.search,
    searchFilters.sortBy,
    searchFilters.sortColumn,
    page,
  ]);

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.contentSection}>
      <Header />
      <List
        mccList={mccList}
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        setPage={setPage}
        getMCCList={getMCCList}
        page={page}
        pageCount={pageCount}
        dataLoading={isLoading}
      />
      </div>

      <AddAndEditMCC
        isModalOpen={isAddMCCModalOpen}
        getMCCList={getMCCList}
        closeModal={closeModal}
      />

      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            borderRadius: "8px",
            background: "rgba(40, 39, 45, 0.85)",
            color: "#fff",
            padding: "16px 24px",
          },
          duration: 5000,
        }}
      >
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== "loading" && (
                  <button
                    type="button"
                    className={styles.toast_dismissal_button}
                    onClick={() => toast.dismiss(t.id)}
                  >
                    <CloseIconWhite />
                  </button>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>

    </div>
  );
};

export default MCCPage;
